import {
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import { theme } from "../../styles/theme";
import { font } from "../../styles/font";
import { ApplicationContext } from "../../context/application_ctx";
import { FieldHeading, FieldValue } from "../userProfileDetail";

export const RepresentativeDetail = () => {
  const { profileDetails, setProfileDetails, setGlobalLoader } =
    useContext(ApplicationContext);


  const [isCompanyProfileEdit, setIsCompanyProfileEdit] = useState({
    information: false,
    description: false,
    address: false,
  });

  // const handleClose = () => {
  //   setSubDialog(false);
  //   setSubscriptionNav(false);
  // };

  useEffect(() => {
    //setGlobalLoader(true)
    setTimeout(() => {
      setGlobalLoader(false);
    }, 2000);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <Box
        display="flex"
        width="100%"
        height="100%"
        flexDirection="column"
        gap="21px"
        flex="1"
      >
        {/* company profile */}
        <Box
          display={"flex"}
          height="100%"
          width="100%"
          // width={profileQuery ? "100%" : "50%"}
          // border={`1px solid ${theme.bgBorder}`}
          // borderRadius="8px"
          // backgroundColor={theme.col_4}
          gap="14px"
          flexDirection="column"
          alignItems="center"
          // padding="22px"
          // border="2px solid blue"
        >
          {/* information */}
          <Box
            display={"flex"}
            width="100%"
            position="relative"
            // height={"100%"}
            gap="14px"
            flexDirection="column"
            padding="22px"
            // border={`1px solid ${theme.bgBorder}`}
            border={`1px solid ${theme.col_2_alpha}`}
            borderRadius="8px"
            backgroundColor={theme.col_4}
            // border="2px solid blue"
          >
            <CompanyInfoTab
              companyDetails={profileDetails}
              setCompanyDetails={setProfileDetails}
              isCompanyProfileEdit={isCompanyProfileEdit}
              setIsCompanyProfileEdit={setIsCompanyProfileEdit}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export const CompanyInfoTab = ({
  companyDetails,
  setCompanyDetails,
  isCompanyProfileEdit,
  setIsCompanyProfileEdit,
}) => {
  // const [isCompanyProfileEdit, setIsCompanyProfileEdit] = useState(false);
  const { setGlobalLoader, assignDetails } = useContext(ApplicationContext);

  useEffect(() => {
    //setGlobalLoader(true)
    setTimeout(() => {
      setGlobalLoader(false);
    }, 2000);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Box
        display={"flex"}
        width="100%"
        // gap="15px"
        // height={"25px"}
        flexDirection="column"
        gap={1}
        // alignItems="center"
        // border="2px solid blue"
      >
        {/* info heading */}
        <Box
          display={"flex"}
          // width="100%"
          flex="1"
          gap="15px"
          // minHeight={"40px"}
          // maxHeight={"40px"}
          // paddingLeft="11px"
          // paddingRight="11px"
          alignItems="flex-start"
          // backgroundColor={theme.col_2_alpha}
          borderRadius="6px"
        >
          <Typography
            // padding="6px 6px 6px 11px"
            flex="1"
            fontSize={font.size.fs_5}
            color={theme.col_2}
            fontFamily={font.family.fm_2}
            fontWeight="bold"
          >
            Information
          </Typography>
        </Box>

        {/* info body */}
        <Box
          display="flex"
          width="100%"
          flexDirection={"column"}
          gap={1}
          alignItems="flex-start"
        >
          <Box display="flex" width="100%" gap={1}>
            <FieldHeading>Representative Name</FieldHeading>
            <FieldValue>
              {!assignDetails?.assignedAdminName
                ? "Adam"
                : assignDetails?.assignedAdminName}
            </FieldValue>
          </Box>

          <Box display="flex" width="100%" gap={1}>
            <FieldHeading> Email</FieldHeading>
            <FieldValue>
              {!assignDetails?.assignedAdminEmail
                ? "adam.chadwick@mindamigo.com"
                : assignDetails?.assignedAdminEmail}
            </FieldValue>
          </Box>
        </Box>

        {/* {isCompanyProfileEdit.information &&
            <UpdateCompanyInfoDialog
              companyDetails={companyDetails}
              setCompanyDetails={setCompanyDetails}
              isCompanyProfileEdit={isCompanyProfileEdit}
              setIsCompanyProfileEdit={setIsCompanyProfileEdit}
            />} */}
      </Box>
    </>
  );
};
